import { render, staticRenderFns } from "./RunnerInfoMenu.vue?vue&type=template&id=8098970c"
import script from "./RunnerInfoMenu.vue?vue&type=script&lang=js"
export * from "./RunnerInfoMenu.vue?vue&type=script&lang=js"
import style0 from "./RunnerInfoMenu.vue?vue&type=style&index=0&id=8098970c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports